export const realRainMarkSources = Object.freeze({
  small: new URL('./realrain-mark-small.svg', import.meta.url).href,
  layered: new URL('./realrain-mark-layered.svg', import.meta.url).href,
  reverse: new URL('./realrain-mark-reverse.svg', import.meta.url).href,
});
